/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

/** Enum for horizontal alignment */
export enum HORIZONTAL_ALIGNMENT{
    LEFT=0,
    CENTER=1,
    RIGHT=2,
    STRETCH=3
}

/** Enum for vertical alignment */
export enum VERTICAL_ALIGNMENT{
    TOP=0,
    CENTER=1,
    BOTTOM=2,
    STRETCH=3
}